import axios from 'axios';
// axios.defaults.baseURL = BASE_URL
let base = BASE_URL;

//let base = "http://mockjs.com/dist/mock"
export const Mocklogin = params => { return axios.post(`${base}/login`,params); };
export const requestLogin = params => { return axios.post(`${base}/api/Accounts/UserLogin`,params); };//登录
export const Logout = params => { return axios.post(`${base}/api/Common/Logout`,params); };//退出登录
export const getSendCode = params => { return axios.post(`${base}/api/SendMsg/Post`,params); };//获取验证码
export const RegisterMan = params => { return axios.post(`${base}/api/Register/Register`,params); };//注册
export const ChangePwd = params => { return axios.post(`${base}/api/Common/ChangePwd`,params); };//修改密码
export const BeginUpload = params => { return axios.get(`${base}/api/Upload/BeginUpload`,{ params: params }); };//上传第一步：每次上传文件前需要申请此批次
export const SimpleUploadToken = params => { return axios.get(`${base}/api/Upload/SimpleUploadToken`,{ params: params }); };//上传第二步
export const SimpleUploadMerge = params => { return axios.post(`${base}/api/Upload/SimpleUploadMerge`,params); };//上传完成通知后台
export const CommitRequest = params => { return axios.post(`${base}/api/Request/CommitRequest`,params); };//提交撤除申请
export const commitGetBysearchParam = params => { return axios.get(`${base}/api/Request/GetBysearchParam`,{ params: params }); };//申请记录列表
export const detailGetBysearchParam = params => { return axios.get(`${base}/api/RequestDetails/GetBysearchParam`,{ params: params }); };//撤除详情
export const RequestReview = params => { return axios.post(`${base}/api/RequestDetails/RequestReview`,params); };//审核人提交审核
export const mangUserGetBysearchParam = params => { return axios.get(`${base}/api/UserList/GetBysearchParam`,{ params: params }); };//用户账号管理列表
export const mangUserChangeStatus = params => { return axios.post(`${base}/api/UserList/ChangeStatus`,params ); };//用户账号管理启用，禁用
export const userLogGetBysearchParam = params => { return axios.get(`${base}/api/SystemLog/GetBysearchParam`,{ params: params }); };//用户操作日志
export const RequestExecute = params => { return axios.post(`${base}/api/RequestDetails/RequestExecute`,params); };//执行人提交审核
export const ReFindPwd = params => { return axios.post(`${base}/api/Login/ReFindPwd`,params); };//忘记密码
export const ReFindPwdCheckVCode = params => { return axios.post(`${base}/api/Register/ReFindPwdCheckVCode`,params); };//找回密码确认验证码
export const GetCountBysearchParam = params => { return axios.get(`${base}/api/RequestCount/GetCountBysearchParam`,{ params: params }); };//信息统计
export const ExportExcel = params => { return axios.get(`${base}/api/Request/ExportExcel`,{ params: params ,responseType:"blob"} ); };//导出excel
///api/Request/BatchRequestExecute
export const BatchRequestExecute = params => { return axios.post(`${base}/api/Request/BatchRequestExecute`,params); };
export const GetOriginalFile = params => { return axios.get(`${base}/api/Common/GetOriginalFile`,{ params: params ,responseType:"blob"} ); };//查看pdf

// 重新提交撤除申请
export const AgainCommitRequest = params => { return axios.post(`${base}/api/Request/AgainCommitRequest`,params); };
// 注销账号
export const CancelUser = params => { return axios.post(`${base}/api/UserList/CancelUser`,params); };
//旧接口
export const getMenuList = params => { return axios.post(`${base}/api/Accounts/UserMenuInfo`,params); };
export const getTabData = params => { return axios.post(`${base}/api/KbaseFP/KSourceList`,params); };
// export const getUserListPage = params => { return axios.get(`${base}/user/listpage`, { params: params }); };
export const removeUser = params => { return axios.get(`${base}/user/remove`, { params: params }); };

export const batchRemoveUser = params => { return axios.get(`${base}/user/batchremove`, { params: params }); };

export const editUser = params => { return axios.get(`${base}/user/edit`, { params: params }); };

export const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };



// WEBPACK FOOTER //
// ./src/api/api.js